import React, { memo } from "react";
import { useSelector } from "react-redux";

import { Reducers } from "../../redux/types";

const SettingIcon = () => {
  const configState = useSelector((state: Reducers) => state.config);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.358"
      height="22.358"
      viewBox="0 0 22.358 22.358"
    >
      <g
        id="prefix__settings_1_"
        data-name="settings (1)"
        transform="translate(.25 .25)"
      >
        <g id="prefix__Group_1411" data-name="Group 1411">
          <path
            id="prefix__Path_2047"
            d="M20.739 8.635l-1.539-.26a8.663 8.663 0 00-.616-1.489l.9-1.265a1.346 1.346 0 00-.146-1.74l-1.352-1.36a1.34 1.34 0 00-.954-.4 1.327 1.327 0 00-.781.251l-1.269.9a8.573 8.573 0 00-1.543-.635l-.256-1.516A1.349 1.349 0 0011.849 0H9.927a1.349 1.349 0 00-1.334 1.129l-.264 1.552a8.449 8.449 0 00-1.484.626L5.589 2.4a1.349 1.349 0 00-1.74.146L2.484 3.91a1.352 1.352 0 00-.146 1.74l.913 1.283a8.462 8.462 0 00-.607 1.493l-1.516.256A1.349 1.349 0 000 10.014v1.922a1.349 1.349 0 001.128 1.334l1.552.265a8.449 8.449 0 00.626 1.484l-.9 1.251a1.346 1.346 0 00.146 1.74l1.361 1.36a1.34 1.34 0 00.954.4 1.327 1.327 0 00.781-.251l1.283-.919a8.638 8.638 0 001.443.594l.256 1.534a1.349 1.349 0 001.333 1.128h1.927a1.349 1.349 0 001.333-1.128l.26-1.534a8.663 8.663 0 001.489-.616l1.265.9a1.34 1.34 0 00.785.251 1.34 1.34 0 00.954-.4l1.361-1.361a1.352 1.352 0 00.146-1.74l-.9-1.269a8.6 8.6 0 00.617-1.479l1.534-.256a1.349 1.349 0 001.128-1.333V9.969a1.333 1.333 0 00-1.123-1.334zm-.105 3.256a.118.118 0 01-.1.119l-1.918.32a.613.613 0 00-.493.452 7.31 7.31 0 01-.794 1.913.617.617 0 00.027.671l1.128 1.589a.124.124 0 01-.014.155l-1.361 1.361a.116.116 0 01-.087.037.112.112 0 01-.068-.023l-1.584-1.128a.617.617 0 00-.671-.027 7.31 7.31 0 01-1.913.794.606.606 0 00-.452.493l-.324 1.918a.118.118 0 01-.119.1H9.968a.118.118 0 01-.119-.1l-.32-1.918a.613.613 0 00-.452-.493 7.59 7.59 0 01-1.872-.767.632.632 0 00-.31-.082.6.6 0 00-.356.114l-1.6 1.137a.136.136 0 01-.068.023.122.122 0 01-.087-.037l-1.359-1.361A.124.124 0 013.411 17l1.123-1.575a.625.625 0 00.027-.676 7.241 7.241 0 01-.8-1.909.625.625 0 00-.493-.452l-1.931-.329a.118.118 0 01-.1-.119v-1.926a.118.118 0 01.1-.119l1.9-.32a.617.617 0 00.5-.457A7.3 7.3 0 014.516 7.2a.61.61 0 00-.032-.667l-1.137-1.6a.124.124 0 01.014-.155l1.36-1.357a.116.116 0 01.087-.037.112.112 0 01.068.023l1.576 1.124a.625.625 0 00.676.027 7.241 7.241 0 011.909-.8.625.625 0 00.452-.493l.328-1.935a.118.118 0 01.119-.1h1.922a.118.118 0 01.119.1l.32 1.9a.617.617 0 00.457.5 7.411 7.411 0 011.959.8.617.617 0 00.671-.027l1.575-1.132a.136.136 0 01.068-.023.122.122 0 01.087.037l1.36 1.365a.124.124 0 01.014.155L17.36 6.489a.617.617 0 00-.027.671 7.31 7.31 0 01.794 1.913.606.606 0 00.493.452l1.918.324a.118.118 0 01.1.119v1.922z"
            fill={configState.isDark ? "#fff" : "#666"}
            stroke={configState.isDark ? "#fff" : "#666"}
            strokeWidth={0.5}
            data-name="Path 2047"
            transform="translate(0 -.001)"
          />
          <path
            id="prefix__Path_2048"
            d="M140.817 136a4.717 4.717 0 104.717 4.717 4.72 4.72 0 00-4.717-4.717zm0 8.2a3.484 3.484 0 113.484-3.484 3.486 3.486 0 01-3.484 3.484z"
            fill={configState.isDark ? "#fff" : "#666"}
            stroke={configState.isDark ? "#fff" : "#666"}
            strokeWidth={0.5}
            data-name="Path 2048"
            transform="translate(-129.886 -129.791)"
          />
        </g>
      </g>
    </svg>
  );
};

export default memo(SettingIcon);
